import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'toWords'
})
export class ToWordsPipe implements PipeTransform {

	static th: string[] = ['', 'thousand', 'million', 'billion', 'trillion'];
	static dg: string[] = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
	static tn: string[] = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
	static tw: string[] = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

	transform(value: number): any {
		let num: string = value.toString();

		num = num.replace(/[\, ]/g, '');
		if (value !== parseFloat(num)) {
			return 'not a num';
		}

		let x: number = num.indexOf('.');

		if (x === -1) {
			x = num.length;
		}

		if (x > 15) {
			return 'too big';
		}

		const n: string[] = num.split('');
		let str: string = '';
		let sk: number = 0;
		for (let i: number = 0; i < x; i++) {
			if ((x - i) % 3 === 2) {
				if (n[i] === '1') {
					str += ToWordsPipe.tn[Number(n[i + 1])] + ' ';
					i++;
					sk = 1;
				}
				else if (n[i] !== '0') {
					str += ToWordsPipe.tw[Number(n[i]) - 2] + ' ';
					sk = 1;
				}
			} else if (n[i] !== '0') {
				str += ToWordsPipe.dg[Number(n[i])] + ' ';
				if ((x - i) % 3 === 0) {
					str += 'hundred ';
				}
				sk = 1;
			}
			if ((x - i) % 3 === 1) {
				if (sk) {
					str += ToWordsPipe.th[(x - i - 1) / 3] + ' ';
				}
				sk = 0;
			}
		}

		if (x !== num.length) {
			const y: number = num.length;
			str += 'point ';
			for (let i: number = x + 1; i < y; i++) {
				str += ToWordsPipe.dg[n[i]] + ' ';
			}
		}

		return str.replace(/\s+/g, ' ').trim();
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/to-words.pipe.ts